import { render, staticRenderFns } from "./BingoGridButton.vue?vue&type=template&id=007e84a7&scoped=true"
import script from "./BingoGridButton.vue?vue&type=script&lang=js"
export * from "./BingoGridButton.vue?vue&type=script&lang=js"
import style0 from "./BingoGridButton.vue?vue&type=style&index=0&id=007e84a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007e84a7",
  null
  
)

export default component.exports